// extracted by mini-css-extract-plugin
export default {"goBack":"GoUp_goBack__qzTwz"};